import clsx from 'clsx';

import { Flex, type FlexProps } from '@commons/containers/Flex';

import styles from './index.module.scss';

/**
 * BannerSectionRegion component.
 */

const BannerSectionRegion = (props: FlexProps) => {
  const { children, className, ref, ...rest } = props;

  const classes = clsx(styles.region, 'h-100', className);

  return (
    <Flex ref={ref} className={classes} {...rest}>
      {children}
    </Flex>
  );
};

export default BannerSectionRegion;
